import React from "react";
import "bulma/css/bulma.css";
import "../App.css";
import { TypeAnimation } from "react-type-animation";
import { BsChevronCompactDown } from "react-icons/bs";
import { Link } from "react-scroll";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

AOS.init();
function Home() {
  const { t } = useTranslation();
  return (
    <section id="home" className="section">
      <div className="columns">
        <div className="column is-two-thirds">
          <div className="content  pt-6 mt-6 has-text-left is-size-4-tablet header">
            <h1 data-aos="fade-up" data-aos-duration="3000" className="block">
              {t("salut")}
            </h1>

            <h1 data-aos="fade-up" data-aos-duration="2500" className="block">
              {t("name")}
            </h1>
            <div data-aos="fade-up" data-aos-duration="2000">
              <TypeAnimation
                sequence={[
                  "MERN",
                  1000,
                  "MERN Developer",
                  1000,
                  "MERN",
                  1000,
                  "",
                  1000,
                  "Data",
                  1000,
                  "Data Science",
                  1000,
                  "Data Science Student",
                  1000,
                ]}
                //  Continuing previous Text
                style={{ fontSize: "2em", color: "hsl(171, 100%, 41%)" }}
                wrapper="h2"
                repeat={Infinity} // Repeat this Animation Sequence infinitely
                speed={20}
                cursor={false}
                className="type"
              />
            </div>

            <div className="columns">
              <div className="column">
                <p
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  className="subtitle has-text-centered is-size-4 has-text-weight-semibold"
                  style={{ lineHeight: "2.5rem" }}
                >
                  {t("header")}
                </p>
              </div>
            </div>

            <br />
            <div
              data-aos="fade-up"
              data-aos-duration="1000"
              className="buttons ml-3 is-mobile"
            >
              <button className="button mr-3   is-medium is-responsive btnTouch">
                <a href="mailto:khefifi.montasssar@gmail.com">
                  {t("btns.touch")}
                </a>
              </button>
              <button
                className="button ml-3  is-outlined is-medium is-responsive getResumeBtn"
                style={{ fontFamily: " 'Jura', sans-serif" }}
              >
                <a
                  href={require("../resume/CV MONTASSAR KHEFIFI.pdf")}
                  target="_black"
                >
                  {t("btns.cv")}
                </a>
              </button>
            </div>
          </div>
        </div>
        <div
          className="column codingImg"
          data-aos="fade-left"
          data-aos-duration="3000"
        >
          <figure className="image container is-256x256">
            <img
              src={require("../images/Hand coding-bro.svg")}
              alt="Coding ..."
            />
          </figure>
        </div>
      </div>

      <Link
        activeClass="active"
        smooth
        spy
        to="about"
        style={{ position: "relative" }}
      >
        <i className="buttons  is-centered">
          <BsChevronCompactDown size={40} color={"hsl(171, 100%, 41%)"} />
        </i>
      </Link>
    </section>
  );
}

export default Home;
